export default {
  async getGuides(context, payload) {
    const { guides, guideFetchDate, guideFetchLanguage } = context.state;
    const oneHourAgo = new Date(Date.now() - 60 * 60 * 1000);

    if (
      guides.length &&
      guideFetchDate &&
      guideFetchDate > oneHourAgo &&
      guideFetchLanguage === payload.language
    ) {
      return;
    }

    context.commit('GET_GUIDES_INIT');
    return this.dispatch('api/searchAcademyGuides', {
      limit: 50,
      page: 1,
      query: '',
      category: '',
      language: payload.language,
    })
      .then((res) => {
        context.commit('SET_GUIDES', {
          guides: res.data,
          language: payload.language,
        });
        return res;
      })
      .catch((err) => {
        context.commit('SET_GET_GUIDES_ERROR', err);
      })
      .finally(() => {
        context.commit('SET_GET_GUIDES_LOADING', false);
      });
  },

  async getGuideByGroup(context, payload) {
    context.commit('SET_GET_GUIDE_BY_GROUP_LOADING', true);
    return this.dispatch('api/getAcademyGuideByGroup', {
      groupId: payload.groupId,
      language: payload.language,
    })
      .then((res) => {
        context.commit('SET_GUIDE_BY_GROUP', res.data);
        return res.data;
      })
      .catch((err) => {
        context.commit('SET_GET_GUIDE_BY_GROUP_ERROR', err);
        return null;
      })
      .finally(() => {
        context.commit('SET_GET_GUIDE_BY_GROUP_LOADING', false);
      });
  },

  async getGuideById(context, payload) {
    let guide = context.state.guides.find(
      (g) => g.academyGuideId === payload.guideId
    );

    if (!guide) {
      context.commit('SET_GUIDES', { guides: [], language: null });
      await context.dispatch('getGuides', { language: payload.language });
      guide = context.state.guides.find(
        (g) => g.academyGuideId === payload.guideId
      );
    }

    return guide ?? null;
  },
};
